import { shopifyGidSchema, ShopifyIdType } from "@redotech/shopify-util/id";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum ShopifyMediaContentTypeEnum {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  MODEL_3D = "MODEL_3D",
  EXTERNAL_VIDEO = "EXTERNAL_VIDEO",
}
export const ShopifyMediaContentTypeSchema = createEnum(
  ShopifyMediaContentTypeEnum,
);

const ShopifyMediaIdSchema = z.union([
  shopifyGidSchema(ShopifyIdType.MediaImage),
  shopifyGidSchema(ShopifyIdType.Video),
  shopifyGidSchema(ShopifyIdType.Model3D),
  shopifyGidSchema(ShopifyIdType.ExternalVideo),
] as const);
export type ShopifyMediaId = z.infer<typeof ShopifyMediaIdSchema>;

const ShopifyPreviewImageSchema_ = z.object({
  url: z.string(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  thumbhash: z.string().nullable(),
});
export const ShopifyPreviewImageSchema: z.ZodType<ShopifyPreviewImage> =
  ShopifyPreviewImageSchema_;
export interface ShopifyPreviewImage
  extends z.infer<typeof ShopifyPreviewImageSchema_> {}

const ShopifyListingMediaSchema_ = z.object({
  id: z.string(),
  shopifyId: ShopifyMediaIdSchema.nullable(),
  alt: z.string().nullable(),
  mediaContentType: ShopifyMediaContentTypeSchema,
  previewImage: ShopifyPreviewImageSchema.nullable(),
});
export const ShopifyListingMediaSchema: z.ZodType<ShopifyListingMedia> =
  ShopifyListingMediaSchema_;
export interface ShopifyListingMedia
  extends z.infer<typeof ShopifyListingMediaSchema_> {}

export type ShopifyListingMediaWithoutRedoIds = Omit<ShopifyListingMedia, "id">;
